export class MailchimpAccount {
  objectType;
  clientId;
  description;
  id;
  name;
  apiKey;
  constructor(obj?: MailchimpAccount) {
    for (const prop in obj) {
      if (obj.hasOwnProperty(prop)) {
        this[prop] = obj[prop];
      }
    }
  }
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/components/organization/accounts/mailchimp-accounts/mailchimp-account.model.ts